import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from "react-intl";
import Dialog from "components/dialog";
import { SimpleButton } from "components/buttons";
import withStyles from "components/with-styles";
import styles from "./styles/second-coach-dialog.css";
import { useImperativeTracking } from "components/tracking";

const SecondCoachDialog = ({ intl, classes, secondCoachUrl, ...props }) => {
  const title = intl.formatMessage({ id: "source.interface.secondCoach.dialog.title" });
  const track = useImperativeTracking();

  const handleClick = useCallback(
    e => {
      track("enters in second coach url: " + secondCoachUrl);
      e.stopPropagation();
    },
    [secondCoachUrl, track],
  );

  return (
    <Dialog title={title} {...props}>
      <div>
        <FormattedMessage id="source.interface.secondCoach.dialog.text" />
      </div>
      <div className={classes.secondCoachActions}>
        {secondCoachUrl ? (
          <div>
            <div>
              <SimpleButton
                onClick={handleClick}
                className={classes.secondCoachButton}
                label={intl.formatMessage({ id: "source.interface.secondCoach.dialog.link" })}
                href={secondCoachUrl}
                target="_blank"
                rel="noopener noreferrer"
              />
              <FormattedMessage id="source.interface.secondCoach.dialog.warning" />
            </div>
          </div>
        ) : (
          <FormattedHTMLMessage id="source.interface.secondCoach.dialog.noService" />
        )}
      </div>
    </Dialog>
  );
};

SecondCoachDialog.propTypes = {
  /**
   * Indica si se muestra a pantalla completa en móviles
   */
  fullScreen: PropTypes.bool,
  /**
   * Indica si el diálogo está abierto
   */
  open: PropTypes.bool,
  /**
   * Callback que se llama al cancelar el diálogo
   */
  onClose: PropTypes.func,
  /**
   * Callback que se llama al aceptar el diálogo
   */
  onAccept: PropTypes.func,
  /**
   * Url de second coach
   */
  secondCoachUrl: PropTypes.string,
};

export default injectIntl(withStyles(styles)(SecondCoachDialog));
